import { NavigationGuardNext, Route } from "vue-router";
import Vue from "vue";

export class HeaderProcess {
  activeIdx: number | null = null;
  processes: { title: string; idx: number }[] = [];
}
type VueWithHeaderProcess = Vue & {
  headerProcess: HeaderProcess[] | undefined;
};
export default Vue.extend({
  mounted() {
    if (!this.isPage) {
      return;
    }
    this.$nextTick(() => {
      this.$store.dispatch("updateHeaderProcess", this.headerProcess);
    });
  },
  watch: {
    headerProcess() {
      if (!this.isPage) {
        return;
      }
      this.$nextTick(() => {
        this.$store.dispatch("updateHeaderProcess", this.headerProcess);
      });
    }
  },
  computed: {
    headerProcess() {
      return undefined;
    },
    isPage() {
      return false;
    }
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    next((vm: Vue) => {
      vm.$nextTick(() => {
        vm.$store.dispatch(
          "updateHeaderProcess",
          (vm as VueWithHeaderProcess).headerProcess
        );
      });
    });
  },
  beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext) {
    next((vm: Vue) => {
      vm.$nextTick(() => {
        vm.$store.dispatch(
          "updateHeaderProcess",
          (vm as VueWithHeaderProcess).headerProcess
        );
      });
    });
  }
});
